import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	contentWrapper: ({ disabledPadding }) => ({
		paddingLeft: theme.spacing(disabledPadding ? 0 : 4),
		paddingRight: theme.spacing(disabledPadding ? 0 : 4),
		marginTop: theme.spacing(2),
	}),
}));

const EditorLeftPanelContent = ({ title, subtitle, content, disabledPadding }) => {
	const classes = useStyles({ disabledPadding });

	return (
		<div className={classes.contentWrapper}>
			<div className="content-sections-wrapper">
				<div className="section-title">{title}</div>
				<div className="section-subtitle">{subtitle}</div>
			</div>
			<div className="content-body">{content}</div>
		</div>
	);
};

EditorLeftPanelContent.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	content: PropTypes.element,
	disabledPadding: PropTypes.bool,
};

export default EditorLeftPanelContent;
